module.exports = __webpack_public_path__ + "img/record-circle-fill.a3c6c516.svg";